import { useSelector } from "react-redux";
import { useState } from "react";
import styles from "./index.module.scss";
import InstallPriceNew from "../../../../commonNew/product/installPriceNew";
import Icon from "../../../../common/icon";

export default function Install({ data }) {
  const { params } = useSelector((state) => state.section);
  const { params: filterParams } = useSelector((state) => state.filter);

  const isAlailable = data.CATALOG?.AVAILABLE;
  const { cityName } = useSelector((state) => state.location);
  const [isShowInstallPrice, setIsShowInstallPrice] = useState(false);

  return (
    <div className={styles.Install}>
      {isShowInstallPrice && (
        <div className={styles.InstallPopup}>
          <span
            className={styles.InstallClose}
            onClick={() => {
              setIsShowInstallPrice(false);
            }}
          >
            <Icon fill={"#333"} id="close" width={22} height={22} />
          </span>
          <InstallPriceNew product={data} />
        </div>
      )}
      {isAlailable &&
        filterParams.marka?.[0] === "lada" &&
        params.sectionId === "635" &&
        ["Москва", "Санкт-Петербург"].includes(cityName) && (
          <a
            className={styles.InstallButton}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setIsShowInstallPrice(!isShowInstallPrice);
            }}
          >
            узнать стоимость установки
          </a>
        )}
    </div>
  );
}
